import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DeleteDemandModifierDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  modifierName: string;
  isDeleting?: boolean;
}

const DeleteDemandModifierDialog = ({
  open,
  onCancel,
  onConfirm,
  modifierName,
  isDeleting = false,
}: DeleteDemandModifierDialogProps) => {
  const { t } = useTranslation('demandModifiers');

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
    >
      <DialogTitle>{t('deleteDialog.title')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('deleteDialog.message', { name: modifierName })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
        <Button
          variant='secondary'
          size='md'
          onClick={onCancel}
          disabled={isDeleting}
        >
          {t('deleteDialog.cancel')}
        </Button>
        <Button
          variant='bad'
          size='md'
          onClick={onConfirm}
          disabled={isDeleting}
        >
          {t('deleteDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDemandModifierDialog;
